import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import PublicAlertsWarningsDetails from '../../subdepartmentdetails/PublicAlertsWarnings'


function PublicAlertsWarnings() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Public Alerts and Warning Systems || Emergency Management";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Emergency Management"
            title="Public Alerts Warnings"
            subtitledown="Department of Emergency Management"
           />
            <PublicAlertsWarningsDetails/>
        </div>
    </>
  )
}

export default PublicAlertsWarnings